import React from 'react';

const History = ({ headlineHistory }) => {
  const scoreColor = score => {
    if (score > 69) {
      return 'bg-info';
    } else if (score > 45 && score < 70) {
      return 'bg-warning';
    }
    return 'bg-danger';
  };

  return (
    <div className="px-sm-5 bg-light">
      <div className="container">
        <h5 className="pt-3 pt-sm-5 header-up">
          LinkedIn Headline Score History
        </h5>
        <div className="container px-sm-2 px-lg-5 py-1 py-sm-3">
          {headlineHistory.map(data => (
            <div
              key={data.headline + data.score}
              className="row my-3 my-sm-4 align-items-center"
            >
              <div className="col-3 col-sm-2 col-xl-1" align="center">
                <div
                  className={`${scoreColor(
                    data.score
                  )} rounded-circle position-relative lg-circle p-3`}
                >
                  <h5 className="text-white">{data.score}</h5>
                </div>
              </div>
              <div className="col d-flex align-items-center">
                <p className="my-auto">
                  <span className="font-override">{data.headline}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default History;
